import { useState } from "react";

const faqItems = [
    {
        question: "1. Как заказать и получить посылку?",
        answer: `
        Шаг 1. Вам нужно зарегистрироваться на сайте www.onza.kg или скачать приложение по следующим ссылкам и пройти там регистрацию:
        -	Ссылка для Iphone (будет доступно в течение ноября),
        -	Cсылка для Andriod (будет доступно в течение ноября).
        После регистрации Вы получите свой KG код, который обязательно нужно указать в адресной строке при заказе. Этот код позволяет идентифицировать Ваш заказ и при получении на наш зарубежный склад принять его на Ваш аккаунт/кабинет. 
        Шаг 2.  
        1)	Выбираете сайт, на котором нужно заказать, товар.
        2)	Выбранный товар на сайте нужно положить в корзину.
        3)	Переходите в корзину и нажимаете выкупить. 
        4)	Нужно указать Ваше имя и фамилию, Вашу электронную почту, туда будут приходить письма, информирующие о ходе доставки Вашего заказа.
        5)	При выкупе вводите адрес нашего зарубежного склада. Адрес можно найти в разделе «Адреса» нашего Приложения или Сайта. Там же будет Ваш KG код указан. Его нужно ввести обязательно. 
        Шаг 3.   
        Вводите данные Вашей карты и оплачиваете. CVV – это 3 цифры на оборотней стороне карты.
        Шаг 4.   
        На электронную почту Вы получите письмо от сайта, где была совершена покупка, о подтверждении заказа и номером заказа. 
        Далее, Вы получите следующие письма от сайта:
        -	Мы отгрузили Ваш товар: в этом письме будет указано ожидаемая дата доставки и будет кнопка с активной ссылкой «Track my order», перейдя по этой ссылке Вы можете отслеживать маршрут Вашей посылки. Трек – это номер отслеживания, он состоит из множества цифр или букв с цифрами. Трек является уникальным. 
        
        -	Мы доставили Ваш товар: в этом письме будет дата и время доставки.  
        Шаг 5.   
        Наш зарубежный склад, получив посылку, сканирует трек и Ваш KG код. Таким образом, посылка попадает на Ваш аккаунт/кабинет. Далее через наш сайт/приложение Вы сможете отследить дальнейший маршрут посылки. 
        До прилета посылки в Бишкек Вам нужно задекларировать заказ свой. Для этого, Вы нажимаете «Декларировать», выбираете валюту, указываете стоимость товара и загружаете инвойс. Декларация нужна для того, чтобы мы предоставили документы таможенным органам согласно законодательству.
        Инвойс – может быть:
        -	просто скрин письма о подтверждении заказа, где видно товар и стоимость заказа. Этот скрин можно легко загрузить, нажав скрепку, или
        -	Pdf чек, которые прислал магазин на почту.
        Посылка окажется в разделе «В пути» как только вылетит в Бишкек. 
        После таможенного досмотра и получения на склад в г. Бишкек посылка окажется в разделе «В Кыргызстане». Значит Вы можете оплатить за доставку и получить свою посылку.
        
    `
    },
    {
        question: "2. Где найти сайты, чтобы заказать?",
        answer: "В разделе «Магазины» Сайта/Приложения Onza.kg Вы найдете ссылки на популярные магазины."
    },
    {
        question: "3. Есть ли ограничения по сумме и весу заказа?",
        answer: `
        В Кыргызстане с 1 апреля 2024 года действует беспошлинный порог ввоза товаров для личного пользования в международных почтовых отправлениях и экспресс-грузах:
        	до 200 евро или 
        	до 31 килограмма. 
        Все таможенные формальности выполняются Onza. 
        
    `
    },
    {
        question: "4. А если сумма заказа выше 200 евро?",
        answer: `
        Каждый случай нужно уточнять через наш WhatsApp, т.к. все случаи индивидуальны.
        В целом, при получении следующих товаров c превышением лимитов выше, Onza запрашивает клиента возместить таможенные пошлины:
        	Техника (телефоны, компьютеры и т.д.), 
        	Автозапчасти, 
        	Люксовые товары (сумки, обувь, одежда),
        	Ювелирные изделия 
        	Габаритный товар стоимостью выше 200 евро.  
        В вышеуказанных случаях, таможенная пошлина исчисляется в размере 15% от стоимости товара с превышающей 200 евро части или при превышении по весу в размере 2 евро за каждый килограмм свыше 31 кг. 
        Органы применяют ту норму (стоимостную или весовую), которая приводит к более высоким платежам. 
        Кроме того, на сайте/в приложении Вы можете добавить получателей (родных, членов семьи). 
        Пример расчета:
        	Если стоимость вашего заказа составила 250 евро, а вес — 35 кг:
        	Превышение по стоимости: 250 евро - 200 евро = 50 евро. Таможенная пошлина составит 50 евро * 15% = 7.5 евро.
        	Превышение по весу: 35 кг - 31 кг = 4 кг. Таможенная пошлина составит 4 кг * 2 евро/кг = 8 евро.
        	В данном случае будет начислена пошлина по весовой норме, то есть 8 евро, так как она выше, чем 7.5 евро по стоимостной норме. 
        Дополнительно, в вышеуказанных случаях 1,500 сом возмещается клиентом за оформление таможенной декларации. 
        
    `
    },
    {
        question: "5. Какие сроки доставки посылок?",
        answer: `
        Этап 1. С момента заказа до получения на наш зарубежный склад: 
        Сроки доставки с момента оформления заказа на сайте до получения нашим складом полностью зависят от сайта, на котором был сделан заказ. У каждого сайта свои сроки доставки, которые можно прочитать в их разделе доставка или при оформлении заказа после ввода адреса нашего склада сайт покажет сроки доставки. 
        Этап 2. С получения заказа на наш зарубежный склад до выдачи в Бишкеке: 
        В США груз передаем на авиадоставку 2 раза в неделю по понедельникам и четвергам. Далее, груз в Бишкеке на выдаче через 7-9 дней.
        В Испании груз передаем на авиадоставку 1 раз в неделю утром по четвергам. Далее, груз в Бишкеке на выдаче через 5-6 рабочих дней (в среду-четверг следующей недели).
        Редко бывают задержки из-за того, что рейс вылетел с опозданием, праздничные дни в США или Испании, задержки на таможне в Кыргызстане из-за различных обстоятельств (например, их система зависла, очередь на досмотр из-за объемов грузов). Обо всех случаях задержки мы информируем клиентов и контролируем ситуацию. 
        
    `
    },
    {
        question: "6. Есть ли товары, которые нельзя заказывать?",
        answer: `
        Скоропортящиеся продукты питания
        Денежные знаки и их эквиваленты
        Оружие
        Токсичные и инфекционные вещества
        Табак, сигареты
        Военное оборудование
        Предметы искусства
        Растения, цветы
        Более 2 штук: парфюмерия, косметические спреи и эфирные масла (разрешено только 2 шт.)
        Взрывоопасные и легковоспламеняющиеся вещества
        Документы
        Литий-ионные батареи и аккумуляторы (разрешены только в устройствах с мощностью не выше 100 Вт)
        
    `
    },
    {
        question: "7.	Зачем мои паспортные данные при регистрации?",
        answer: `Согласно законодательству Кыргызской Республики, импорт товаров на территории страны подлежит обязательному декларированию. 
        Все таможенные формальности мы берем на себя. Вам достаточно при регистрации указать паспортные данные и адрес. 
        Мы полностью соблюдаем законодательство о защите персональных данных.`
    },
    {
        question: "8. Как я узнаю о доставке и где я могу получать посылки?",
        answer: "Статус посылок Вы можете отслеживать на Сайте/в Приложении. Кроме того, Вы получите сообщение на WhatsApp и электронную почту. Адрес ПВЗ указаны в разделе Контакты. Обратите, пожалуйста, внимание на часы работы и обеденные перерывы. "
    },
    {
        question: "9.	Как рассчитывается стоимость доставки при наличии коробок? ",
        answer: `
        Стоимость доставки считается по физическому и объёмному весу: Объёмный вес = (длина × ширина × высота) / 6000
        
        Расчёт стоимости доставки: Если объёмный вес больше физического, дополнительно к тарифу по физическому весу оплачивается 60 сом за каждые 100 г превышения объёмного веса над физическим весом.
        
        👉 Если объёмный вес равен или меньше физического — оплачивается только физический вес.
        
    `
    },
    {
        question: "10.	Хочу заказать телефон/ноутбук/технику, какие пошлины будут? ",
        answer: `
        Таможенные пошлины составляю 15% от суммы заказа выше 200 евро. 
        Пример: Если телефон 1200 долл, то минусуем 200 евро в долларах, 1200-200*1.1=980 долл 980*15%=147 долл будут пошлины. 
        
        Дополнительно за таможенное декларирование мы выставляем 1500 сом (за брокерские услуги).
        
        Для получения imei для телефона необходима таможенная декларация, которую мы предоставляем. Порядок регистрации на сайтe можно найти на сайте https://imei.kg/faq 
        Для регистрации устройства для личного пользования включая доставку через международные почтовые и курьерские отправления, подлежат обязательной регистрации в ГСИ в срок не позднее 30 дней с момента первого подключения к сети операторов Кыргызской Республики. 
        
    `
    },
    {
        question: "11.	Некоторые американские сайты не принимают банковскую карту? ",
        answer: "Мы выкупаем в таких случаях. Вам нужно скинуть ссылку на товар в разделе «Купи вместо меня» или на наш WhatsApp. Тариф по выкупу с использованием нашей американской карты составляет 10% от суммы заказа."
    }
];

export default function FAQ() {
    const [openIndex, setOpenIndex] = useState(null);

    return (
        <div style={styles.container}>
            <h1
                style={{
                    fontSize: "28px",
                    fontWeight: "600",
                    margin: "0",
                    marginBottom: "10px",
                    color: "#103d64",
                }}
            >
                Вопросы ответы
            </h1>
            {faqItems.map((item, index) => (
                <div key={index} style={styles.item}>
                    <div
                        style={styles.question}
                        onClick={() => setOpenIndex(openIndex === index ? null : index)}
                    >
                        <span>{item.question}</span>
                        <span style={styles.icon}>
                            {openIndex === index ? "−" : "+"}
                        </span>
                    </div>

                    {openIndex === index && (
                        <div style={styles.answer}>
                            {item.answer.split("\n").map((line, i) => (
                                <p key={i} style={{ margin: "6px 0" }}>{line}</p>
                            ))}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}

const styles = {
    container: {
        maxWidth: "900px",
        margin: "0 auto",
        padding: "20px 0",
        overflow: "auto",
        width: "calc(100% - 16px)"
    },
    item: {
        border: "1px solid #103d64",
        borderRadius: "12px",
        marginBottom: "14px",
        overflow: "hidden",
        background: "#fff"
    },
    question: {
        padding: "16px 20px",
        cursor: "pointer",
        fontWeight: "600",
        background: "#f3f8fc",
        display: "flex",
        justifyContent: "space-between",
        color: "#103d64"
    },
    icon: {
        fontSize: "22px",
        lineHeight: "22px"
    },
    answer: {
        padding: "16px 20px",
        background: "#ffffff",
        lineHeight: "1.55",
        color: "#103d64"
    }
};
